import {useCallback} from 'react';

interface IUpdateTagsArgs {
    uuid: string,
    tags: string[],
}

type UpdateMonitor = (_args: IUpdateTagsArgs) => {unwrap: () => Promise<unknown>};

export const useUpdateMonitorTags = (updateMonitor: UpdateMonitor, uuid: string | undefined) => {
    return useCallback(async(tags: string[]) => {
        if (!uuid) {
            return;
        }

        await updateMonitor({uuid, tags}).unwrap();
    }, [uuid, updateMonitor]);
};

export default useUpdateMonitorTags;
